import { supertypeClass } from '@haventech/amorphic';
import { Customer } from '../../../../common/js/customer/Customer';
import { ClientBaseQuote } from '../ClientBaseQuote';
@supertypeClass({ toClient: true, toServer: true })
export class CoverpathAnnuityQuote extends ClientBaseQuote {
  static new(customer: Customer) {
    return new CoverpathAnnuityQuote().init(customer);
  }

  init(customer: Customer): CoverpathAnnuityQuote {
    this.product = 'CASREC';
    this.productType = 'Annuity';
    super.init(customer);
    return this;
  }

  // Checks if all properties necessary to get a quote are present
  verifyProperties(): boolean {
    return true;
  }

  public hasBeenInitialized(): boolean {
    return true;
  }

  get initialPurchaseAmount(): number {
    return this.faceAmount;
  }

  set initialPurchaseAmount(amount) {
    this.faceAmount = amount;
  }
}
